export enum PlaidAccessTokenStatus {
    Active = 'active',
    Inactive = 'inactive',
    Disconnected = 'disconnected',
}
